<script src="bin/oms.min.js?spiderfier_callback=mapLibReadyHandler" async defer />
<template>
  <div class="map">
    <MapGoogle />
    <MapFilters />
    <MapNavigation />
  </div>
</template>
<script>
import MapGoogle from '@/components/dashboard/MapGoogle'
import MapFilters from '@/components/dashboard/MapFilters'
import MapNavigation from '@/components/dashboard/MapNavigation'

export default {
  name: 'Map',

  components: {
    MapGoogle,
    MapFilters,
    MapNavigation,
  },
}
</script>
